<template>
  <b-table-simple outlined class="mb-1">
    <b-thead>
      <tr role="tab" @click="toggleAccordion">
        <th>
          <div class="flex flex-row justify-between items-center cursor-pointer">
            <div class="flex items-center">
              <span>{{ appModule.name }}</span>
              <img class="ml-2" src="@/assets/images/checkmark.png" alt="check" />
            </div>
            <div>
              <span v-if="!isExpanded">&#8964;</span>
              <span v-else>&#62;</span>
            </div>
          </div>
        </th>
      </tr>
    </b-thead>

    <b-tbody v-show="isExpanded">
      <tr>
        <td>


          <div class="relative w-full tabs-wrapper">


            <button v-if="currentPage > 0" class="absolute left-0 top-2  transform -translate-y-1/2 z-10 px-3 py-2 "
              @click="prevPage">
              <span class="chevron">
                &#8249;
              </span>
            </button>



            <div class="flex justify-between items-center w-full  tabs-content-wrapper">
              <div class="grid grid-cols-5  w-full">


                <div v-for="(submodule) in visibleTabs" :key="submodule.id"
                  class="text-center py-2 px-3  cursor-pointer border-b transition " :class="[
                    activeTab === submodule.name ? 'active-tab' : 'inactive-tab'
                  ]" @click="setActiveTab(submodule.name, submodule.privileges, submodule.slug)">
                  {{ submodule.name }}
                </div>
              </div>
            </div>


            <button v-if="(currentPage + 1) * tabsPerPage < appModule.submodules.length"
              class="absolute right-0 top-2 transform -translate-y-1/2 z-10 px-3 py-2" @click="nextPage">

              <span class="chevron">
                &#8250;
              </span>
            </button>
          </div>

          <div class="mt-3" v-if="activePrivileges.length">
            <div class="flex justify-between">
              <h2 class="font-bold">Privileges</h2>
              <b-form-checkbox v-model="selectAllPrivileges">Access All Privileges</b-form-checkbox>
            </div>

            <div class="priv-wrap">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group id="privileges-check-box" v-model="privilegeManager"
                  :aria-describedby="ariaDescribedby">
                  <div class="grid grid-rows-5 grid-flow-col  privilege-grid">
                    <div v-for="(privilege) in activePrivileges" :key="privilege.id" class="privilege-item">
                      <b-form-checkbox :value="privilege.id">
                        {{ privilege.name }}</b-form-checkbox>
                    </div>
                  </div>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </td>
      </tr>
    </b-tbody>
  </b-table-simple>
</template>


<script>

export default {
  props: {
    appModule: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    selectedRoleObjects: {
      type: Array,
      required: true,
    },
    selectedPrivileges: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
      accessAllModules: false,
      privilegeManager: [],
      isChecked: true,

      selectAllPrivileges: false,
       updatingFromParent: false,

      tabsPerPage: 5,
      currentPage: 0,
      activeTab: '',
      activeSlug: '',
      activePrivileges: []
    };
  },

  computed: {
    visibleTabs() {
      const start = this.currentPage * this.tabsPerPage
      const end = start + this.tabsPerPage
      return this.appModule.submodules.slice(start, end)
    }
  },

  methods: {
    toggleAccordion() {
      this.isExpanded = !this.isExpanded;
    },

    nextPage() {
      if ((this.currentPage + 1) * this.tabsPerPage < this.appModule.submodules.length) {
        this.currentPage++
      }
    },
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--
      }
    },
    setActiveTab(tab, privileges, slug) {
      this.activeTab = tab
      this.activePrivileges = privileges
      this.activeSlug = slug

      
   
    }
  },
  watch: {
    selectedPrivileges: {
    handler(newVal) {
      console.log("👀 Selected Privileges received from parent:", newVal);
      if (this.updatingFromParent) {
        // Skip to avoid loop
        this.updatingFromParent = false;
        return;
      }
      const allModulePrivileges = this.appModule.submodules.flatMap(sub =>
        sub.privileges.map(priv => priv.id)
      );
      this.privilegeManager = newVal.filter(id => allModulePrivileges.includes(id));
    },
    immediate: true,
    deep: true,
  },

    privilegeManager(newVal) {
      this.updatingFromParent = true;

      this.$emit("selectedPrivileges", {
        moduleSlug: this.appModule.slug,
        privileges: newVal
      });

    },

    selectAllPrivileges(newVal) {
      if (newVal) {
        this.privilegeManager = this.activePrivileges.map(p => p.id);
      } else {
        this.privilegeManager = [];
      }
    },

  },
};

</script>

<style scoped>
.collapsed>.when-open {
  display: none;
}

.not-collapsed>.when-closed {
  display: none;
}

.active-tab {
  font-weight: 600;
  background-color: #FFFFFF;
  border-bottom: 4px solid #F7B538;
}

.inactive-tab {
  border-bottom: 4px solid #F0F4FE;
  opacity: 0.5;
  /* faded text */
  transition: opacity 0.3s ease;
}

.inactive-tab:hover {
  opacity: 0.75;
  /* slightly more visible on hover */
}

.tabs-content-wrapper {
  /* border: 2px solid blue; */
  width: 85%;
  margin: 0 auto;
}



button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.chevron {
  color: #F7B538;
  font-size: 24px;
}

.priv-wrap {
  border: 1px solid #F5F4FA;
  margin-top: 4px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px #2E294E05;
}
</style>
